import React from 'react'

import { AbsoluteBgImageContainer } from './ImageBackgroundContainer.styles'

export const ImageBackgroundContainer = ({ imageUrl }) => <AbsoluteBgImageContainer as="div" imageUrl={imageUrl} />
